import React from 'react';
import { FactSheetRow, FactSheetPlaceholder, FactSheetCell, CTARow, CTAPlaceholder, CTACell } from './index.styles';
import AccountDetailsLink, { getFactSheetUrl } from '../../shared/AccountDetailsLink';
import PlanAction from '../../shared/PlanAction';
import type { PlanButtonsProps } from '../../types';

const PlanButtons: React.FC<PlanButtonsProps> = ({
  orderedPlans,
  currentPlanId,
  switchPermitted,
  onSelectPlan,
  toggleManageDrawer,
  onVoucher,
}) => (
  <>
    <FactSheetRow>
      <FactSheetPlaceholder />
      {orderedPlans.map(plan => (
        <FactSheetCell key={plan.id}>
          <AccountDetailsLink href={getFactSheetUrl(plan.family)} planName={plan.cardTitle} />
        </FactSheetCell>
      ))}
    </FactSheetRow>

    <CTARow>
      <CTAPlaceholder />
      {orderedPlans.map(plan => (
        <CTACell key={plan.id}>
          <PlanAction
            currentPlanId={currentPlanId}
            planId={plan.id}
            switchPermitted={switchPermitted}
            product={plan.product}
            onSelectPlan={() => onSelectPlan(plan)}
            onManage={toggleManageDrawer}
            onVoucher={onVoucher}
          />
        </CTACell>
      ))}
    </CTARow>
  </>
);

export default PlanButtons;
